import { createFileRoute } from '@tanstack/react-router'
import { PettyCashPage } from '@/features/petty-cash/pages/PettyCashPage'

export const Route = createFileRoute('/_app/petty-cash/')({
  component: PettyCashPage,
})
